<template>
  <div id="calendar-stats" class="fill-height">
    <v-date-picker
      class="fill-height"
      ref="picker"
      v-model="date"
      full-width
      locale="pt"
      :color="$primary"
      :events="Eventos"
      @click:date="OpenDate"
    ></v-date-picker>
  </div>
</template>

<script>
export default {
  props: {
    aniversarios: Array,
    colheitas: Array
  },
  data: () => ({
    arrayEvents: null,
    date: new Date().toISOString().substr(0, 10)
  }),

  mounted() {
    var div = document.querySelector(".v-picker__body div")
    var legend = document.createElement("div")
    legend.className = "legenda"
    legend.innerHTML =
      "<div><span class='point point-blue'></span><span class='point-name'>Aniversários</span></div><div><span class='point point-red'></span><span class='point-name'>Colheitas</span></div>"

    div.append(legend)
  },

  methods: {
    OpenDate(date) {
      this.$eventBus.$emit("RightMenu", {
        title: this.$moment(date).format("LL"),
        isUser: false,
        aniversarios: this.aniversarios.filter(el => {
          return el.data == date
        }),
        colheitas: this.colheitas.filter(el => {
          return el.data == date
        })
      })
    },
    Eventos(date) {
      if (
        this.aniversarios.findIndex(el => {
          return el.data == date
        }) > -1 &&
        this.colheitas.findIndex(el => {
          return el.data == date
        }) > -1
      )
        return ["#0000ff", "#ff0000"]

      if (
        this.aniversarios.findIndex(el => {
          return el.data == date
        }) > -1
      )
        return "#0000ff"

      if (
        this.colheitas.findIndex(el => {
          return el.data == date
        }) > -1
      )
        return "#ff0000"

      return false
    }
  }
}
</script>
<style>
#calendar-stats .v-picker__title__btn {
  color: #666666;
  display: flex;
  justify-content: center;
  text-transform: uppercase;
  font-weight: bold;
}

#calendar-stats .v-picker__title {
  background-color: #ffffff !important;
  padding: 16px 16px 0 16px !important;
}

#calendar-stats .v-date-picker-header {
  margin-top: -5px;
  color: #666666 !important;
}

#calendar-stats .v-date-picker-header__value > div button {
  color: #8b8b8b !important;
  font-weight: 400;
  text-transform: uppercase;
  font-size: 14px;
}

#calendar-stats .v-date-picker-title__date {
  font-size: 17px;
}

#calendar-stats .v-picker__body .legenda {
  display: flex;
  margin-top: 20px;
  font-size: 13px;
  color: #7d7d7d;
}
#calendar-stats .v-picker__body .legenda div {
  padding: 0 30px;
  position: relative;
}

#calendar-stats .point-name {
  margin-left: 15px;
}

#calendar-stats .point-blue {
  background-color: blue;
}

#calendar-stats .point-red {
  background-color: red;
}

#calendar-stats .point {
  width: 10px;
  height: 10px;
  border-radius: 50px;
  position: absolute;
  margin-top: 5px;
}
</style>